export function extractTextFromTipTap(node: any): string {
  if (!node) return "";

  if (node.type === "text" && typeof node.text === "string") {
    return node.text;
  }

  if (Array.isArray(node.content)) {
    return node.content.map(extractTextFromTipTap).join(" ");
  }

  return "";
}

export function getEstimatedReadingTime(
  contentNode: any,
  wordsPerMinute = 275
): string | undefined {
  const text = extractTextFromTipTap(contentNode);
  if (!text) return undefined;

  const words = text.trim().split(/\s+/).length;
  const minutes = Math.ceil(words / wordsPerMinute);
  if (minutes === 1) {
    return `${minutes} minut`;
  }
  return `${minutes} minuter`;
}
